export const routerPath = {
  root: '/studio-attendance-per-class-report',
};

export const getColumns = () => [
  {
    id: 'className',
    label: 'Class',
    align: 'left',
    nameForSort: 'class_name',
  },
  {
    id: 'classAttendance',
    label: 'Attendance',
    align: 'center',
    nameForSort: 'class_attendance',
  },
  {
    id: 'classUtilization',
    label: 'Utilization %',
    align: 'center',
    nameForSort: 'class_utilization',
  },
  {
    id: 'classCostValue',
    label: 'Value',
    align: 'center',
    nameForSort: 'class_cost_value',
  },
];

export const getFilters = ({ dateRange }) => [
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
];
